// BDQ (Rascovsky et al., 2011) — Behavioural Dysfunction Questionnaire scoring
// from the BDQ_Auswertung.xlsx workbook.
//   "Calculation sheet" J7-J11 = domain means (mean of item ratings 0-5)
//   J12                        = total score (mean of 5 domain means)
//   K7-K11                     = sex-specific deviant verdict
//                                Disinhibition       M > 0.89, W > 0.7
//                                Apathy              M > 2.3,  W > 1.0
//                                Loss of empathy     M > 1.1,  W > 1.1
//                                Perseverative beh.  M > 1.0,  W > 0.7
//                                Hyperorality        M > 2.0,  W > 1.3
// A domain is "auffällig" when its score is strictly greater than the
// patient's-sex cutoff. The total score is informational only — no cutoff.

export const BDQ_DOMAINS = [
  { key: "disinhibition",  labelFr: "Désinhibition",              labelDe: "Disinhibition",          male: 0.89, female: 0.7 },
  { key: "apathy",         labelFr: "Apathie",                    labelDe: "Apathie",                male: 2.3,  female: 1.0 },
  { key: "lossOfEmpathy",  labelFr: "Perte d'empathie",           labelDe: "Empathieverlust",        male: 1.1,  female: 1.1 },
  { key: "perseverative",  labelFr: "Comportement persévératif",  labelDe: "Perseveratives Verhalten", male: 1.0,  female: 0.7 },
  { key: "hyperorality",   labelFr: "Hyperoralité",               labelDe: "Hyperoralität",          male: 2.0,  female: 1.3 },
];

function resolveSex(patientGenre) {
  if (patientGenre === "H") return "male";
  if (patientGenre === "F") return "female";
  return null;
}

const fmt = (n) => (Math.round(n * 100) / 100).toFixed(2);

export function calcBDQ({ scores, total, patientGenre, lang = "de" }) {
  const sex = resolveSex(patientGenre);
  const labelKey = lang === "fr" ? "labelFr" : "labelDe";
  const verdictLabel = (auffaellig) =>
    lang === "fr"
      ? auffaellig ? "anormal" : "normal"
      : auffaellig ? "auffällig" : "unauffällig";

  const resultData = [];
  const lines = [];
  let anyAuffaellig = false;
  let anyDecided = false;

  if (Number.isFinite(total)) {
    const globalLabel = lang === "fr" ? "Score global" : "Gesamtwert";
    const v = fmt(total);
    resultData.push({ name: "globalScore", label: globalLabel, value: v, italic: true });
    lines.push(`${globalLabel}: ${v}`);
  }

  for (const dim of BDQ_DOMAINS) {
    const sc = scores?.[dim.key];
    if (!Number.isFinite(sc)) continue;
    const cutoff = sex === "male" ? dim.male : sex === "female" ? dim.female : null;
    const label = dim[labelKey];
    const scoreStr = fmt(sc);

    let value;
    if (cutoff == null) {
      value = scoreStr;
    } else {
      const auffaellig = sc > cutoff;
      anyDecided = true;
      if (auffaellig) anyAuffaellig = true;
      value = `${verdictLabel(auffaellig)} (${scoreStr}/${cutoff})`;
    }

    resultData.push({ name: dim.key, label, value, italic: true });
    lines.push(`${label}: ${value}`);
  }

  return {
    resultData,
    resultText: lines.join("\n"),
    sex,
    anyAuffaellig,
    anyDecided,
  };
}
